import { WorkSpaceStop } from 'src/app/core/types';

interface NormalizedStop {
  id: number | null;
  name: string | null;
  address: string | null;
  country: string | null;
  city: string | null;
  postalCode: string | null;
}

export function areWorkspaceStopsChanged(
  savedStops: WorkSpaceStop[] | undefined,
  initialStops: WorkSpaceStop[] | undefined,
): boolean {
  if (initialStops === undefined) {
    return (savedStops?.length ?? 0) > 0;
  }
  const saved = normalizeStops(savedStops);
  const initial = normalizeStops(initialStops);
  if (saved.length !== initial.length) {
    return true;
  }
  return saved.some((stop, index) => !sameStop(stop, initial[index]));
}

function normalizeStops(stops: WorkSpaceStop[] | undefined): NormalizedStop[] {
  return (stops ?? []).map((stop) => ({
    id: stop.id ?? null,
    name: blankToNull(stop.name),
    address: blankToNull(stop.address),
    country: blankToNull(stop.country),
    city: blankToNull(stop.city),
    postalCode: blankToNull(stop.postalCode),
  }));
}

function blankToNull(value: string | undefined | null): string | null {
  return value ? value : null;
}

function sameStop(left: NormalizedStop, right: NormalizedStop): boolean {
  return (
    left.id === right.id &&
    left.name === right.name &&
    left.address === right.address &&
    left.country === right.country &&
    left.city === right.city &&
    left.postalCode === right.postalCode
  );
}
